import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//import Card from '../shared/Card';
//import { formatPrice } from '../../utils/helpers';
import SelectItemButton from './partials/SelectItemButton';
import classNames from 'classnames';

const GearItem = ({ item, isSelected, isIncluded, onAdd, onRemove, defaultVariant, defaultVariant2, defaultVariant3, defaultQuantity, defaultStep}) => {

  const [selectedVariant, setSelectedVariant] = useState(defaultVariant);
  const [selectedVariant2, setSelectedVariant2] = useState(defaultVariant2);
  const [selectedVariant3, setSelectedVariant3] = useState(defaultVariant3);
  const [selectedQuantity, setSelectedQuantity] = useState(defaultQuantity);
  const [currentStep, setCurrentStep] = useState(defaultStep);

  useEffect(() => {
    setSelectedVariant(defaultVariant);
    setSelectedVariant2(defaultVariant2);
    setSelectedVariant3(defaultVariant3);
    setSelectedQuantity(defaultQuantity);
    setCurrentStep(defaultStep);
  }, [defaultVariant, defaultVariant2, defaultVariant3, defaultQuantity, defaultStep]);

  console.log('Gear item:', item);

  // Selects count
  var steps = 1;
  if(item.gear_options.options[0].suboptions){
    steps++;
    if(item.gear_options.options[0].suboptions.options[0].suboptions){
      steps++;
    }
  }
  console.log('Steps:', steps);
  console.log('currentStep:', currentStep);

  const hasValidData = () => {
    if (!selectedVariant) {
      return false;
    }
    if (selectedVariant === "0") {
      return false;
    }
    if(currentStep === 2 && steps > 1){
      if (!selectedVariant2) {
        return false;
      }
      if (selectedVariant2 === "0") {
        return false;
      }
    }
    if((currentStep === 3 || currentStep === 4) && steps > 2){
      if (!selectedVariant3) {
        return false;
      }
      if (selectedVariant3 === "0") {
        return false;
      }
    }
    return true;
  };

  const formatGearPrice = (price) => {
    if(parseFloat(price) === 0) return 'Included';
    return `$${new Intl.NumberFormat('en-US').format(price)}`;
  };

  const renderGearSummary = (item, isIncluded) => {
    console.log('currentStep:', currentStep);
    console.log('selectedVariant:', selectedVariant);
    console.log('selectedVariant2:', selectedVariant2);
    console.log('selectedVariant3:', selectedVariant3);
    var price = item.price;
    var inventory_quantity = 0;
    var foundVariant = 0;
    for (let option of item.gear_options.options) {
      //console.log('Check selected:', option.id, selectedVariant);
      if((`${option.id}` === selectedVariant) || (option.id === selectedVariant)){
        price = option.price;
        inventory_quantity = option.inventory_quantity;
        foundVariant = 1;
        if(option.suboptions){
          for (let suboption of option.suboptions.options) {
            if(`${suboption.id}` === selectedVariant2){
              price = suboption.price;
              inventory_quantity = suboption.inventory_quantity;
              foundVariant = 2;
              if(suboption.suboptions){
                for (let subsuboption of suboption.suboptions.options) {
                  if(`${subsuboption.id}` === selectedVariant3){
                    price = subsuboption.price;
                    inventory_quantity = subsuboption.inventory_quantity;
                    foundVariant = 3;
                  }
                }
              }
            }
          }
        }
      }
    }

    console.log('inventory_quantity:', inventory_quantity);
    console.log('price:', price);
    console.log('foundVariant:', foundVariant);

    var inventory_quantitys = [];
    if(inventory_quantity > 1){
      if(inventory_quantity > 10) inventory_quantity = 10;
      for (let i = 2; i <= inventory_quantity; i++) {
        inventory_quantitys.push(i);
      }
    }

    var select_qty_disabled = true;
    var show_price = false;
    if(hasValidData()){
      select_qty_disabled = false;
      show_price = true;
    }
    if(isSelected){
      select_qty_disabled = true;
    }
    show_price = false;

    if(isIncluded) {
      select_qty_disabled = true;
    }

    console.log('select_qty_disabled:', select_qty_disabled);

    return (
      <div className="field__gear__price">
        <label
          className={classNames('field__label')}
        >
          <select
            name={`gear-qty`}
            onChange={(e) => setSelectedQuantity(e.target.value)}
            defaultValue={`1`}
            disabled={select_qty_disabled}
          >
          <option value={`1`}>
            {`1`}
          </option>
          {inventory_quantitys.map((value, index) => (
            <option value={value}>
              {value}
            </option>
          ))}
          </select>
        </label>
        {(show_price === true) && (
        <h4>{`Price: $${price}`}</h4>
        )}
      </div>
    );
  };

  // Get first select
  var options = [];
  var option_item = {};
  var sub_options = [];
  var sub_option_item = {};
  var sub_options_name = '';
  var sub_sub_options = [];
  var sub_sub_option_item = {};
  var sub_sub_options_name = '';
  for (let option of item.gear_options.options) {
      option_item = {};
      option_item.value = option.id;
      option_item.label = option.name;
      options.push(option_item);
      if(currentStep === 2 || currentStep === 3 || currentStep === 4){
        if((`${option.id}` === selectedVariant || option.id === selectedVariant) && option.suboptions){
          sub_options_name = option.suboptions.name;
          for (let suboption of option.suboptions.options) {
            sub_option_item = {};
            sub_option_item.value = suboption.id;
            sub_option_item.label = suboption.name;
            sub_options.push(sub_option_item);
            if(currentStep === 3 || currentStep === 4){
              if(`${suboption.id}` === selectedVariant2 && suboption.suboptions){
                sub_sub_options_name = suboption.suboptions.name;
                for (let subsuboption of suboption.suboptions.options) {
                  sub_sub_option_item = {};
                  sub_sub_option_item.value = subsuboption.id;
                  sub_sub_option_item.label = subsuboption.name;
                  sub_sub_options.push(sub_sub_option_item);
                }
              }
            }
          }
        }
      }
  }

  var is_no_option = false;
  if(options.length === 1){
    //if(options[0].label === "Default Title"){
      is_no_option = true;
      if (!selectedVariant) {
        console.log('!!!! Set selected for ', item.title, options[0].label);
        setSelectedVariant(options[0].value);
        setCurrentStep(2);
      }
    //}
  }


  // For Disabled Options
  var is_sub_options = false;
  var is_sub_sub_options = false;
  for (let option of item.gear_options.options) {
    if(option.suboptions){
      sub_options_name = option.suboptions.name;
      for (let suboption of option.suboptions.options) {
        is_sub_options = true;
        if(suboption.suboptions){
          sub_sub_options_name = suboption.suboptions.name;
          for (let subsuboption of suboption.suboptions.options) {
            if(subsuboption.id){
              is_sub_sub_options = true;
            }
          }
        }
      }
    }
  }

  var sub_options_disabled = true;
  var sub_sub_options_disabled = true;
  if(sub_options.length > 0) {
    if (selectedVariant) {
      sub_options_disabled = false;
    }
  }
  if(sub_sub_options.length > 0) {
    if (selectedVariant2) {
      sub_sub_options_disabled = false;
    }
  }

  var select_disabled = true;
  if(hasValidData()){
    select_disabled = false;
  }

  var options_disabled = false;
  if(isSelected){
    options_disabled = true;
    sub_options_disabled = true;
    sub_sub_options_disabled = true;
  }

  var hideStartingAtLabel = false;
  var price = item.price;
  if(hasValidData()){
    for (let option of item.gear_options.options) {
      if((`${option.id}` === selectedVariant) || (option.id === selectedVariant)){
        price = option.price;
        hideStartingAtLabel = true;
        if(option.suboptions){
          for (let suboption of option.suboptions.options) {
            if(`${suboption.id}` === selectedVariant2){
              price = suboption.price;
              hideStartingAtLabel = true;
              if(suboption.suboptions){
                for (let subsuboption of suboption.suboptions.options) {
                  if(`${subsuboption.id}` === selectedVariant3){
                    price = subsuboption.price;
                    hideStartingAtLabel = true;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  console.log('options:',options);
  console.log('sub_options:',sub_options);
  console.log('sub_options:',sub_sub_options);

  var showCardTitleCategory = false;
  var cardTitleCategory = '';
  if(item.cross_sell_categories.length){
    showCardTitleCategory = true;
    cardTitleCategory = item.cross_sell_categories[0];
    cardTitleCategory = cardTitleCategory.replaceAll('_', ' ');
  }

  return (
    <div className="card">
      {item.cross_sell_new_product && (
        <img className="card__new-item-badge" src={window.newitemtag} width={50} height={50} alt={item.name} />
      )}
      <div className="card__header">
        <h5 className="card__title">
          {item.name}
          {showCardTitleCategory && (
            <div className="card__title-category" dangerouslySetInnerHTML={{__html: cardTitleCategory }} />
          )}
        </h5>
        <div className="card__price">
          <div className="card__price-amount">
            {formatGearPrice(price)}
          </div>

          {!hideStartingAtLabel && (
            <div className="card__price-label">Starting at</div>
          )}
        </div>
      </div>

    <div className="card__body">
      <div className="extras-item__body">
        {item.image_url && (
          <img src={item.image_url} width={150} alt={item.name} />
        )}

        <p dangerouslySetInnerHTML={{__html: item.description }} />

        {(is_no_option === true) && (
        <label className={classNames('field__label')} style={{ display: 'none' }}>
          <select
            name={`step1`}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedVariant(value);
              setCurrentStep(2);
            }}
            defaultValue={options[0].value}
            value={options[0].value}
          >
          <option value={options[0].value} selected>
            {options[0].label}
          </option>
          </select>
        </label>
        )}

        {(is_no_option === false) && (
        <label className={classNames('field__label')}>
          <select
            name={`step1`}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedVariant(value);
              setCurrentStep(2);
            }}
            defaultValue={`0`}
            disabled={options_disabled}
          >
          <option value={`0`}>
            {`Select ${item.gear_options.name}`}
          </option>
          {options.map((value, index) => (
            <option value={value.value}>
              {value.label}
            </option>
          ))}
          </select>
        </label>
        )}

        {(sub_options.length > 0 || is_sub_options) && (
          <label className={classNames('field__label')}>
            <select
              name={`step2`}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedVariant2(value);
                setCurrentStep(3);
              }}
              defaultValue={`0`}
              disabled={sub_options_disabled}
            >
            <option value={`0`}>
              {`Select ${sub_options_name}`}
            </option>
            {sub_options.map((value, index) => (
              <option value={value.value}>
                {value.label}
              </option>
            ))}
            </select>
          </label>
        )}

        {(sub_sub_options.length > 0 || is_sub_sub_options) && (
          <label className={classNames('field__label')}>
            <select
              name={`step3`}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedVariant3(value);
                setCurrentStep(4);
              }}
              defaultValue={`0`}
              disabled={sub_sub_options_disabled}
            >
            <option value={`0`}>
              {`Select ${sub_sub_options_name}`}
            </option>
            {sub_sub_options.map((value, index) => (
              <option value={value.value}>
                {value.label}
              </option>
            ))}
            </select>
          </label>
        )}

        <div className="field__summary">
            <Fragment>
              {renderGearSummary(item, isIncluded)}
              <SelectItemButton
                isSelected={isSelected}
                isIncluded={isIncluded}
                onAdd={() => onAdd(selectedVariant, selectedVariant2, selectedVariant3, selectedQuantity)}
                onRemove={onRemove}
                disabled={select_disabled}
              />
            </Fragment>
        </div>

      </div>

    </div>

    </div>
  );

  /*
  const hasValidData = () => {
    if (!selectedVariant) {
      return false;
    }
    if (selectedVariant === "0") {
      return false;
    }
    return true;
  };

  const renderGearSummary = (item) => {
    var price = 0;
    var inventory_quantitys = [];
    var inventory_quantity = 0;
    for (let shirt_option of item.gear_options) {
      for (let short_option of shirt_option.suboptions) {
        console.log('short_option_id:', selectedShortSize, short_option.id);
        if(`${short_option.id}` === selectedShortSize){
          console.log('short_option:', short_option);
          price = short_option.price;
          inventory_quantity = short_option.inventory_quantity;
        }
      }
    }
    if(inventory_quantity){
      for (let i = 1; i <= inventory_quantity; i++) {
        inventory_quantitys.push(i);
      }
    }
    return (
      <div className="field__gear__price">
        <label
          className={classNames('field__label')}
        >
          <select
            name={`gear-qty`}
            onChange={(e) => setSelectedQuantity(e.target.value)}
            defaultValue={`1`}
          >
          {inventory_quantitys.map((value, index) => (
            <option value={value}>
              {value}
            </option>
          ))}
          </select>
        </label>
        <h4>{`Price: $${price}`}</h4>
      </div>
    );
  };


  var shirt_options = [];
  var short_options = [];
  var shirt_item = {};
  var short_item = {};
  shirt_item.value = '0';
  shirt_item.label = 'Select shirt size';
  shirt_options.push(shirt_item);
  for (let shirt_option of item.gear_options) {
    shirt_item = {};
    shirt_item.value = shirt_option.name;
    shirt_item.label = shirt_option.name;
    shirt_options.push(shirt_item);
    if (selectedShirtSize === shirt_option.name) {
      short_item.value = '0';
      short_item.label = 'Select short size';
      short_options.push(short_item);
      for (let short_option of shirt_option.suboptions) {
        short_item = {};
        short_item.value = short_option.id;
        short_item.label = short_option.name;
        short_options.push(short_item);
      }
    }
  }

  return (
    <Card title={item.name} startingPrice={item.price}>
      <div className="extras-item__body">
        {item.image_url && (
          <img src={item.image_url} width={150} alt={item.name} />
        )}

        <p dangerouslySetInnerHTML={{__html: item.description }} />

        <label className={classNames('field__label')}>
          <select
            name={`shirt_options`}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedShirtSize(value)
            }}
            defaultValue={`0`}
          >
          {shirt_options.map((value, index) => (
            <option value={value.value}>
              {value.label}
            </option>
          ))}
          </select>
        </label>

        {hasValidShirt() && (
          <label className={classNames('field__label')}>
            <select
              name={`short_options`}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedShortSize(value)
              }}
              defaultValue={`0`}
            >
            {short_options.map((value, index) => (
              <option value={value.value}>
                {value.label}
              </option>
            ))}
            </select>
          </label>
        )}

        <div className="field__summary">
          {hasValidData() && (
            <Fragment>
              {renderGearSummary(item)}
              <SelectItemButton
                isSelected={isSelected}
                isIncluded={isIncluded}
                onAdd={() => onAdd(selectedShirtSize, selectedShortSize, selectedQuantity)}
                onRemove={onRemove}
              />
            </Fragment>
          )}
        </div>

      </div>

    </Card>
  );
  */

};

GearItem.propTypes = {
  item: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  isIncluded: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  defaultVariant: PropTypes.string.isRequired,
};

export default GearItem;
